import { useStyles } from "../../../style/styles";
import { IProps } from "./types";


const Navbar = (props: IProps) => {
	const classes = useStyles()
  return (
    <>
			<div className={classes.chatNavbar}>
				<b>MESSAGING</b>
			</div>
    </>
  )
}

export default Navbar